var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.8 0h28.4v40H12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d52b1e",
    d: "M-1.3 0h14.1v40H-1.3zm42.5 0h14.1v40H41.2zM17 19.3l-1.1.4 5 4.5c.5 1.1 0 1.5-.4 2l5.6-.6-.2 5.6h1.2l-.3-5.6 5.6.7c-.3-.8-.6-1.2-.3-2.3l5-4.3-.8-.3c-.7-.6.3-2.7.5-4 0 0-3 1-3.2.4l-.8-1.4-2.7 3q-.4 0-.5-.3l1.3-6.3-2 1.1q-.3.1-.5-.2L26.6 8l-2 4q0 .2-.4 0l-1.9-1 1.2 6.2q-.2.3-.6.2l-2.6-3c-.3.6-.5 1.4-1 1.6s-2-.3-3-.5c.4 1.2 1.5 3.3.8 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/ca.056f7d5ad98e4d68e097aa77bfd27813.svg";
export { ForwardRef as ReactComponent };